import styled from 'styled-components';
import { Box } from 'grommet';

export const StyledPanel = styled(Box)`
  border-radius: var(--app-radius);
  box-shadow: var(--elevation);
  background: var(--page-card-bg);
  padding: 1rem;
`;

export const StyledChartWrap = styled(Box)`
  height: 19rem;
  width: 100%;
`;

export const StyledScrollWrap = styled(Box)`
  max-height: 22rem;
  overflow-y: auto;
`;

export const StyledTable = styled.table`
  width: 100%;
  border-collapse: collapse;
  font-size: 0.84rem;
  color: var(--page-table-text);

  thead th {
    position: sticky;
    top: 0;
    background: var(--page-card-bg);
    text-align: left;
    font-weight: 700;
    padding: 0.65rem 0.55rem;
    border-bottom: 1px solid var(--page-table-border);
    color: var(--page-table-header);
    white-space: nowrap;
  }

  thead th:not(:first-child) {
    text-align: right;
  }

  tbody td {
    padding: 0.56rem 0.55rem;
    border-bottom: 1px solid var(--page-table-border);
    vertical-align: middle;
    color: var(--page-table-text);
  }

  tbody td:not(:first-child) {
    text-align: right;
  }

  tbody tr:last-child td {
    border-bottom: none;
  }

  tbody tr:hover {
    background: var(--page-alt-bg);
  }
`;
